<script>
export default {
  name: 'fee-amount',
  props: {
    tag: {
      type: String,
      required: false,
      default: 'em'
    },
    unit: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      amount: ''
    }
  },
  render(createElement) {
    return createElement(this.tag, this.amount + this.unit)
  },
  created() {
    this.getFeeAmount()
  },
  methods: {
    getFeeAmount() {
      this.$fetch('/api/OrganizationEnterprise/GetPayAmount').then(result => {
        this.amount = result
      })
    }
  }
}
</script>

